import axios from "axios";
import React, { useEffect, useState } from "react"
import { useParams } from "react-router-dom";
import { useHistory } from "react-router-dom";
import styled from 'styled-components';
import './Detail.scss';

let box = styled.div`
    padding : 20px;
`;

let 제목 = styled.h4`
    font-size : 25px;
    color : ${ props => props.색상 }
`;

// class Detail2 extends React.Component {
//     componentDidMount() {

//     }

//     componentWillUnmount() {

//     }
// }

function Detail(props) {

    let [alert, alert변경] = useState(true);
    let [inputData, inputData변경] = useState(''); 

    // 위의 compoent 코드와 같은 기능을 한다.
    // useEffect훅
    // 컴포넌트가 mount 되었을 때
    // 컴포넌트가 update 될때
    // 특정 코드를 실행할 수 있음
    useEffect(()=>{

        // axios.get()

        // setTimeout(function() {
        // })
        let 타이머 = setTimeout(() => {
            alert변경(false)
        }, 2000);

        // 컴포넌트가 사라질때 코드를 실행
        // return function test() {
        return ()=> {
            // setTimeout 해제
            clearTimeout(타이머)
        }
    // 실행조건을 넣을 수 있다.
    // alert가 UPDATAE 될 떄만 실행 된다.
    },[alert]);

    

    let { id } = useParams();
    let history = useHistory();
    // let findShoes = props.shoes.find(function(상품){
    //     return 상품.id == id
    // });
    let findShoes = props.shoes.find(x => x.id == id);

    console.log(findShoes);

    return (
        <div className="container">
            <box>
                <제목 className="red">Detail</제목>
            </box>
            
            { inputData }

            <input onChange={(e)=>{
                inputData변경(e.target.value)
            }}/>

            

            {
                // if를 사용하지 못하기 때문에 삼항 연산자를 사용한다.
                alert === true
                ? (
                    <div className="my-alert2">
                        <p>재고가 얼마 남지 않았습니다.</p>
                    </div>)
                : null
            }
            

            <div className="row">
                <div className="col-md-6">
                    <img src={findShoes.shoesImg} width="100%" />
                </div>
                <div className="col-md-6 mt-4">
                    <h4 className="pt-5">{findShoes.title}</h4>
                    <p>{findShoes.content}</p>
                    <p>{findShoes.price}원</p>

                    <Info 재고={props.재고}></Info>

                    <button className="btn btn-danger" onClick={ ()=>{
                        props.재고변경([9, 11, 12])
                    }}>주문하기</button>
                    <button className="btn btn-danger" onClick={()=>{
                        // history.goBack()
                        history.push('/')
                      }} >뒤로가기</button>
                </div>
            </div>
        </div>
    )

    function Info(props){
        return (
            <p>재고 : {props.재고[id]}</p>
        )
    }
}

export default Detail;